import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import '../static/SOF.css';

const StatementOfFaith = () => {
    const { t } = useLanguage();

    return (
        <section className='sof-section' id='SOF'>
            <div  className='sof-content'>
                <h2 className = "siteHeadings" style={{textAlign:"center"}}>{t('sof.heading')}</h2>
                <ol>
                    <li>{t('sof.item1')}</li>
                    <li>{t('sof.item2')}</li>
                    <li>{t('sof.item3')}</li>
                    <li>{t('sof.item4')}</li>
                    <li>{t('sof.item5')}</li>
                    <li>{t('sof.item6')}</li>
                    <li>{t('sof.item7')}</li>
                    <li>{t('sof.item8')}</li>
                    <li>{t('sof.item9')}</li>
                    <li>{t('sof.item10')}</li>
                    <li>
                      {t('sof.item11.pre')}
                      <a href="https://www.sbc.net/" target="_blank" rel="noopener noreferrer">{t('sof.item11.sbc')}</a>
                      {t('sof.item11.mid')}
                      <a href="https://bfm.sbc.net/" target="_blank" rel="noopener noreferrer">{t('sof.item11.bfm')}</a>
                      {t('sof.item11.post')}
                    </li>
                </ol>
            </div>
        </section>
    );
}

export default StatementOfFaith;
